// AI 내담자 연습 표시용 값. 목록·상세가 함께 쓴다.

// 연습 상태 표시 문구.
export const AI_CLIENT_STATUS_LABELS = { completed: '완료', active: '진행 중', prepared: '준비됨' };

// 면담 시간을 표시한다. 끝나지 않은 연습은 서버가 예정 시간을 주므로 "예정"을 붙인다.
export function formatDuration(row) {
    if (row.duration_minutes == null) return '—';
    return `${row.status === 'completed' ? '' : '예정 '}${row.duration_minutes}분`;
}
